var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHamburger = function SvgHamburger(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    "aria-hidden": "true",
    viewBox: "0 0 20 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.07143 13.913C0.479695 13.913 7.89675e-07 14.3802 7.37944e-07 14.9565C6.86213e-07 15.5328 0.479696 16 1.07143 16L18.9286 16C19.5203 16 20 15.5328 20 14.9565C20 14.3802 19.5203 13.913 18.9286 13.913L1.07143 13.913Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C5.17312e-08 7.4237 0.479694 6.95652 1.07143 6.95652L18.9286 6.95652C19.5203 6.95652 20 7.4237 20 8C20 8.5763 19.5203 9.04348 18.9286 9.04348L1.07143 9.04348C0.479695 9.04348 -5.17308e-08 8.5763 0 8Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24449e-07 1.04348C6.7618e-07 0.467182 0.479695 -5.03815e-08 1.07143 0L18.9286 1.93546e-07C19.5203 2.43928e-07 20 0.467181 20 1.04348C20 1.61978 19.5203 2.08696 18.9286 2.08696L1.07143 2.08696C0.479696 2.08696 5.72718e-07 1.61977 6.24449e-07 1.04348Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHamburger, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hamburger.a12246fc.svg";
export { ForwardRef as ReactComponent };